import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import SupportChat from './SupportChat';
import MicroserviceHealthDashboard from '../MicroserviceHealthDashboard';
import './SupportDashboard.css';

const SupportDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState('chat');

  return (
    <div className="support-dashboard">
      <Card className="dashboard-card">
        <CardHeader>
          <CardTitle>Support & System Health</CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="chat" className="flex items-center gap-2">
                Support Chat
              </TabsTrigger>
              <TabsTrigger value="health" className="flex items-center gap-2">
                API Health
              </TabsTrigger>
            </TabsList>
            
            <TabsContent value="chat">
              <SupportChat />
            </TabsContent>
            
            <TabsContent value="health">
              <MicroserviceHealthDashboard refreshInterval={30000} />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default SupportDashboard;